import { get } from './api';
import {
  CarouselDataItem,
  //   StatisticsDataType,
} from '../components';
// import { WhatsNextItem } from '../pages/Dashboard/WhatsNext';

// Mock data
import { data as whatsNextData } from '../mock-data/whats-next.mock';
// import { data as statisticsData } from '../mock-data/carousel.mock';

export const endpoints = {
  whatsNextUrl: `${window.envConfig.SELLERS_API_BASE_URL}whatsnext`,
  statisticsUrl: `${window.envConfig.SELLERS_API_BASE_URL}Dashboard/aggregatedata`,
};

export const getWhatsNext = async () => {
  // const results = await get<WhatsNextItem[]>({ url: endpoints.whatsNextUrl });
  // return results;

  return whatsNextData;
};

export const getStatistics = async (
  token: string,
  urlParams: Record<string, string>
) => {
  const results = await get<CarouselDataItem[]>({
    url: endpoints.statisticsUrl,
    urlParams,
    token,
  });
  return results;

  // return statisticsData;
};
